/**
 * Stop withdraws the messages Alpinist has not read yet and sends their texts
 * back (AB#6760), so they can be edited and sent again instead of retyped.
 */

// Ids whose text already went back into a draft. Module scope on purpose: the
// socket replays recent events to every new connection, so one withdrawal also
// reaches a reconnect, a conversation switch and a reopened panel, and must
// still put its text back only once per page.
const handedBack = new Set<string>()

/** The texts of withdrawn messages not handed back before, in the order they were sent. */
export const takeWithdrawnTexts = ({
  message_ids: ids,
  texts,
}: {
  readonly message_ids: readonly string[]
  readonly texts: readonly string[]
}): string[] => {
  const fresh = ids.filter((id) => !handedBack.has(id))
  fresh.forEach((id) => handedBack.add(id))
  if (!fresh.length) return []
  // Texts that do not pair up with the ids cannot be matched; hand all back once.
  if (texts.length !== ids.length) return [...texts]
  return texts.filter((_, index) => fresh.includes(ids[index]))
}

/** The withdrawn texts first, as they were written first, then the draft; one per line. */
export const mergeIntoDraft = (texts: readonly string[], draft: string): string =>
  [...texts, draft].filter((part) => part.trim()).join('\n')
